<template>
	<v-scrollable class="h-full pb-lg text-gray-500">
		<table
			class="w-full table-fixed border-separate border-t border-gray-900/10"
			style="border-spacing: 0"
		>
			<tbody>
				<tr v-for="column in columns" :key="column.key">
					<th
						class="sticky left-0 w-32 border border-t-0 border-gray-900/10 bg-white p-sm text-left font-normal text-black"
					>
						{{ column.title }}
					</th>

					<td
						v-for="parcel in parcels"
						:key="parcel.id"
						class="w-24 border-r border-b border-gray-900/10 p-sm text-right font-bold even:bg-gray-500/5"
						:class="{
							'text-gray-300': !parcel[column.key],
							'text-black': !!parcel[column.key],
						}"
					>
						<template v-if="parcel[column.key]">
							{{ parcel[column.key]?.toLocaleString() }} {{ column.suffix }}
						</template>

						<template v-else> - </template>
					</td>
				</tr>
			</tbody>
		</table>
	</v-scrollable>
</template>

<script setup lang="ts">
import type {ViewProductDetailsQuery} from "@pkg/shared/graphql";

type DetailProduct = Extract<
	ViewProductDetailsQuery["product"],
	{__typename: "SimpleProduct"}
>;
type ProductParcel = DetailProduct["parcels"][0];

defineProps<{
	parcels: ProductParcel[];
}>();

const {t} = useI18n();

interface Column {
	title: string;
	key: keyof ProductParcel;
	suffix?: string;
}

const columns: Column[] = [
	{
		title: t("parcel.quantity"),
		key: "quantity",
		suffix: t("parcel.quantity-suffix"),
	},
	{
		title: t("parcel.products"),
		key: "productQuantity",
		suffix: t("parcel.quantity-suffix"),
	},
	{
		title: t("parcel.height"),
		key: "height",
		suffix: "cm",
	},
	{
		title: t("parcel.length"),
		key: "depth",
		suffix: "cm",
	},
	{
		title: t("parcel.width"),
		key: "width",
		suffix: "cm",
	},
	{
		title: t("parcel.volume"),
		key: "volume",
		suffix: "m³",
	},
	{
		title: t("parcel.weight"),
		key: "weight",
		suffix: "kg",
	},
];
</script>

<i18n lang="json">
{
	"et": {
		"parcel": {
			"quantity-suffix": "tk",
			"quantity": "Pakke",
			"products": "Tooteid",
			"height": "Kõrgus",
			"length": "Pikkus",
			"width": "Laius",
			"volume": "Maht",
			"weight": "Kaal"
		}
	},
	"fi": {
		"parcel": {
			"quantity-suffix": "kpl",
			"quantity": "Paketteja",
			"products": "Tuotteita",
			"height": "Korkeus",
			"length": "Pituus",
			"width": "Leveys",
			"volume": "Tilavuus",
			"weight": "Paino"
		}
	}
}
</i18n>
